export enum Layouts {
  DEFAULT = 'DEFAULT',
  APPBARONLY = 'APPBARONLY',
  NONE = 'NONE',
}
